var map = {
	"./absence.svg": [
		73375,
		73375
	],
	"./access.svg": [
		13172,
		13172
	],
	"./accountant.svg": [
		63786,
		63786
	],
	"./activate.svg": [
		69249,
		69249
	],
	"./activation.svg": [
		99550,
		99550
	],
	"./api.svg": [
		62386,
		62386
	],
	"./area-manager.svg": [
		31031,
		31031
	],
	"./area.svg": [
		59781,
		59781
	],
	"./arrow-down.svg": [
		27514,
		27514
	],
	"./arrow-left.svg": [
		88465,
		88465
	],
	"./arrow-right.svg": [
		26300,
		26300
	],
	"./arrow-up.svg": [
		33897,
		33897
	],
	"./arrowLongRight.svg": [
		38667,
		38667
	],
	"./assign.svg": [
		12537,
		12537
	],
	"./assistant.svg": [
		8042,
		8042
	],
	"./attachment.svg": [
		79837,
		79837
	],
	"./attendance.svg": [
		25915,
		25915
	],
	"./back.svg": [
		48971,
		48971
	],
	"./badge.svg": [
		56147,
		56147
	],
	"./bell.svg": [
		82205,
		82205
	],
	"./blank.svg": [
		78120,
		78120
	],
	"./break.svg": [
		62035,
		62035
	],
	"./building.svg": [
		96850,
		96850
	],
	"./calculator.svg": [
		2358,
		2358
	],
	"./calendar-outlined.svg": [
		48379,
		48379
	],
	"./calendar-time.svg": [
		18990,
		18990
	],
	"./calendar.svg": [
		2676,
		2676
	],
	"./cancel.svg": [
		47456,
		47456
	],
	"./capacity.svg": [
		48522,
		48522
	],
	"./cash.svg": [
		61951,
		61951
	],
	"./change.svg": [
		36546,
		36546
	],
	"./chart.svg": [
		17874,
		17874
	],
	"./chat.svg": [
		25420,
		25420
	],
	"./chat2.svg": [
		28438,
		28438
	],
	"./check-in.svg": [
		55202,
		55202
	],
	"./check.svg": [
		32366,
		32366
	],
	"./checkbox-checked.svg": [
		20597,
		20597
	],
	"./checkbox-interminate.svg": [
		12912,
		12912
	],
	"./checkbox-unchecked.svg": [
		68226,
		68226
	],
	"./checkboxes.svg": [
		74469,
		74469
	],
	"./clipboard.svg": [
		93516,
		93516
	],
	"./clock.svg": [
		69759,
		92140
	],
	"./close1.svg": [
		33735,
		33735
	],
	"./close2.svg": [
		62228,
		62228
	],
	"./close4.svg": [
		77450,
		77450
	],
	"./coffee.svg": [
		78058,
		78058
	],
	"./comment.svg": [
		94205,
		94205
	],
	"./computer.svg": [
		38941,
		38941
	],
	"./connection.svg": [
		61586,
		61586
	],
	"./country-manager.svg": [
		7202,
		7202
	],
	"./country.svg": [
		24568,
		24568
	],
	"./covid.svg": [
		78889,
		78889
	],
	"./cycle.svg": [
		38316,
		38316
	],
	"./dashboard.svg": [
		93854,
		93854
	],
	"./dayswaps-logo.svg": [
		42488,
		42488
	],
	"./dayswaps.svg": [
		48496,
		48496
	],
	"./deactivation.svg": [
		18327,
		18327
	],
	"./delete.svg": [
		44039,
		44039
	],
	"./deselect.svg": [
		62535,
		62535
	],
	"./display.svg": [
		9432,
		9432
	],
	"./dots.svg": [
		31162,
		31162
	],
	"./download.svg": [
		77790,
		77790
	],
	"./duplicate.svg": [
		93729,
		93729
	],
	"./edit.svg": [
		39354,
		39354
	],
	"./email.svg": [
		24730,
		24730
	],
	"./exchange.svg": [
		64817,
		64817
	],
	"./export.svg": [
		9840,
		9840
	],
	"./external.svg": [
		46643,
		46643
	],
	"./file-docx.svg": [
		96063,
		96063
	],
	"./file-jpg.svg": [
		40582,
		40582
	],
	"./file-pdf.svg": [
		89545,
		89545
	],
	"./file-png.svg": [
		7994,
		7994
	],
	"./file-xlsx.svg": [
		65188,
		65188
	],
	"./file-zip.svg": [
		2230,
		2230
	],
	"./file.svg": [
		64244,
		64244
	],
	"./filters.svg": [
		34567,
		34567
	],
	"./fullscreen.svg": [
		45253,
		45253
	],
	"./group.svg": [
		49631,
		49631
	],
	"./hash.svg": [
		24514,
		24514
	],
	"./help.svg": [
		11407,
		11407
	],
	"./hide.svg": [
		52606,
		52606
	],
	"./history.svg": [
		77582,
		77582
	],
	"./holidays.svg": [
		99965,
		99965
	],
	"./home.svg": [
		67815,
		67815
	],
	"./hourglass.svg": [
		24332,
		24332
	],
	"./hours-division.svg": [
		12085,
		12085
	],
	"./info.svg": [
		42278,
		42278
	],
	"./insurance.svg": [
		64034,
		64034
	],
	"./invoice.svg": [
		9883,
		9883
	],
	"./items.svg": [
		23786,
		23786
	],
	"./law.svg": [
		19550,
		19550
	],
	"./layout-sidebar-right-expand.svg": [
		29907,
		29907
	],
	"./leave.svg": [
		54563,
		54563
	],
	"./lifebuoy.svg": [
		25715,
		48096
	],
	"./like.svg": [
		20371,
		20371
	],
	"./link.svg": [
		85638,
		85638
	],
	"./loader.svg": [
		4279,
		4279
	],
	"./location.svg": [
		80875,
		80875
	],
	"./lock-open.svg": [
		57400,
		57400
	],
	"./lock.svg": [
		22935,
		22935
	],
	"./menu-dots.svg": [
		79908,
		79908
	],
	"./minus.svg": [
		57834,
		57834
	],
	"./modules.svg": [
		46933,
		46933
	],
	"./monitor.svg": [
		30292,
		30292
	],
	"./moon.svg": [
		91629,
		91629
	],
	"./morning.svg": [
		76982,
		76982
	],
	"./multi-select.svg": [
		73950,
		73950
	],
	"./number.svg": [
		64301,
		64301
	],
	"./offer.svg": [
		24644,
		24644
	],
	"./open.svg": [
		10390,
		10390
	],
	"./overview.svg": [
		28235,
		28235
	],
	"./payroll.svg": [
		71477,
		71477
	],
	"./pen-outlined.svg": [
		36730,
		36730
	],
	"./pen.svg": [
		40239,
		40239
	],
	"./people.svg": [
		2507,
		2507
	],
	"./performance.svg": [
		39892,
		39892
	],
	"./person-add.svg": [
		32959,
		32959
	],
	"./person.svg": [
		29178,
		6797
	],
	"./phone-plus.svg": [
		32615,
		32615
	],
	"./phone.svg": [
		43022,
		43022
	],
	"./pin.svg": [
		92803,
		92803
	],
	"./planned.svg": [
		13340,
		13340
	],
	"./plus.svg": [
		70402,
		70402
	],
	"./positions.svg": [
		99702,
		99702
	],
	"./print.svg": [
		16767,
		16767
	],
	"./productivity.svg": [
		97385,
		19766
	],
	"./properties.svg": [
		40474,
		18093
	],
	"./publish.svg": [
		58371,
		58371
	],
	"./question.svg": [
		10278,
		10278
	],
	"./radio-checked.svg": [
		95095,
		95095
	],
	"./radio-unchecked.svg": [
		34128,
		34128
	],
	"./report.svg": [
		5928,
		5928
	],
	"./save.svg": [
		37485,
		37485
	],
	"./score.svg": [
		84760,
		84760
	],
	"./search.svg": [
		67638,
		67638
	],
	"./send.svg": [
		87904,
		87904
	],
	"./settings-full.svg": [
		83717,
		83717
	],
	"./settings.svg": [
		93477,
		93477
	],
	"./settings2.svg": [
		90957,
		90957
	],
	"./shift.svg": [
		86534,
		86534
	],
	"./shop-manager.svg": [
		1880,
		1880
	],
	"./sick.svg": [
		35732,
		35732
	],
	"./single-select.svg": [
		61191,
		61191
	],
	"./sort.svg": [
		47662,
		47662
	],
	"./standards.svg": [
		89744,
		89744
	],
	"./standby-plugin.svg": [
		39323,
		39323
	],
	"./standby.svg": [
		73117,
		73117
	],
	"./star.svg": [
		43286,
		43286
	],
	"./stats.svg": [
		83611,
		83611
	],
	"./success.svg": [
		11471,
		11471
	],
	"./sun.svg": [
		63348,
		63348
	],
	"./switch.svg": [
		54998,
		54998
	],
	"./template.svg": [
		72724,
		72724
	],
	"./template2.svg": [
		47726,
		47726
	],
	"./terminal.svg": [
		83878,
		83878
	],
	"./text.svg": [
		74099,
		74099
	],
	"./time.svg": [
		71665,
		71665
	],
	"./tip.svg": [
		25185,
		25185
	],
	"./turnover.svg": [
		79873,
		79873
	],
	"./unlock.svg": [
		5082,
		5082
	],
	"./unoccupied.svg": [
		35999,
		35999
	],
	"./update.svg": [
		86377,
		86377
	],
	"./upload.svg": [
		5973,
		5973
	],
	"./vacation.svg": [
		41027,
		41027
	],
	"./values.svg": [
		74808,
		74808
	],
	"./view.svg": [
		83801,
		83801
	],
	"./warning-triangle.svg": [
		77595,
		77595
	],
	"./warning.svg": [
		44954,
		44954
	],
	"./wildcard.svg": [
		52256,
		52256
	],
	"./work.svg": [
		16869,
		16869
	],
	"./world.svg": [
		7178,
		7178
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88413;
module.exports = webpackAsyncContext;